import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";

//====================================
//系统管理 --主数据配置

import Metaconfig from "../views/systerm/dataConfig/metaconfig.vue"; //数据配置
import Classes from "../views/systerm/dataConfig/classes.vue"; //主数据配置

//列表配置

import Lists from "../views/systerm/dataConfig/list/lists.vue"; //列表配置
import ListInfo from "../views/systerm/dataConfig/list/listInfo.vue"; //列表配置

// import Lists from "../views/systerm/dataConfig/list/index.vue"; //列表配置
// import Lists from "../views/systerm/dataConfig/list/list.vue"; //列表配置
// import listInfo from "../views/systerm/dataConfig/list/info.vue"; //列表配置
// import listValue from "../views/systerm/dataConfig/list/info.vue"; //列表配置
// import listWhereused from "../views/systerm/dataConfig/list/info.vue"; //列表配置

import folderList from "../views/workBench/search/folderList.vue";

//自动编号
import AutoNumbers from "../views/systerm/dataConfig/autoNumber/autoNumbers.vue"; //列表配置
import AutoNumbersInfo from "../views/systerm/dataConfig/autoNumber/autoNumbersInfo.vue";
import AutoNumbersWhereUsed from "../views/systerm/dataConfig/autoNumber/autoNumbersWhereUsed.vue";
//属性编号
import CodeNumbers from "../views/systerm/dataConfig/codeNumbers.vue"; //列表配置
//标准配置
import Criteria from "../views/systerm/dataConfig/criteria/criteria.vue"; //标准配置

//流程配置 workflow
import Workflows from "../views/systerm/workflow/Workflows.vue"; //流程配置
import WorkflowInfo from "../views/systerm/workflow/WorkflowInfo.vue"; //流程配置
import PpmWorkflows from "../views/systerm/workflow/ppmWorkflows.vue"; //流程配置
import PpmWorkflowInfo from "../views/systerm/workflow/PpmWorkflowInfo.vue"; //流程配置
import ProjectWorkflows from "../views/systerm/workflow/projectWorkflows.vue"; //流程配置
import ProjectWorkflowInfo from "../views/systerm/workflow/projectWorkflowInfo.vue"; //流程配置

//系统配置
import Notifications from "../views/systerm/adminConfig/notifications.vue"; //流程配置
import Integration from "../views/systerm/adminConfig/Integration.vue"; //流程配置
import Preference from "../views/systerm/adminConfig/Preference.vue"; //流程配置

//用户配置
//用户
import Users from "../views/systerm/userConfig/user/Users.vue"; //
import UserItem from "../views/systerm/userConfig/user/UserItem.vue"; //用户配置首页
// import UserInfo from '../views/systerm/userConfig/user/UserInfo.vue' //用户配置
import UserHistory from "../views/systerm/userConfig/user/UserHistory.vue"; //用户配置
import UserPreferences from "../views/systerm/userConfig/user/UserPreferences.vue"; //用户配置
import UserAuthorization from "../views/systerm/userConfig/user/UserAuthorization.vue"; //用户配置
import UserGroup from "../views/systerm/userConfig/user/UserGroup.vue"; //用户配置
import CreateUser from "../views/systerm/userConfig/user/CreateUser.vue"; //用户创建
import RolePermission from "../views/systerm/userConfig/user/RolePermission.vue"; //用户-角色权限
//管理员修改用户密码
import AdminUpdatePsd from "../views/systerm/userConfig/user/adminUpdatePsd.vue"; //密码修改

//用户组
import UserGroups from "../views/systerm/userConfig/userGroup/UserGroups.vue"; //
import UserGroupItem from "../views/systerm/userConfig/userGroup/UserGroupItem.vue"; //用户组配置首页
// import UserGroupInfo from '../views/systerm/userConfig/userGroup/UserGroupInfo.vue' //用户组配置
import CreateUserGroup from "../views/systerm/userConfig/userGroup/CreateUserGroup.vue"; //用户组创建

import UserGroupUsers from "../views/systerm/userConfig/userGroup/UserGroupUsers.vue"; //
import UserGroupHistory from "../views/systerm/userConfig/userGroup/UserGroupHistory.vue"; //
import UserGroupAssignment from "../views/systerm/userConfig/userGroup/UserGroupAssignment.vue"; //

//角色
// import Roles from "../views/systerm/userConfig/role/Roles.vue"; //用户角色配置
//权限
import Privs from "../views/systerm/userConfig/priv/Privs.vue"; //user权限配置/

import privInfo from "../views/systerm/userConfig/priv/privInfo.vue";
import privRole from "../views/systerm/userConfig/priv/privRole.vue";
import privUser from "../views/systerm/userConfig/priv/privUser.vue";

import Roles from "../views/systerm/userConfig/role/Roles.vue"; //user权限配置/

import rolesInfo from "../views/systerm/userConfig/role/rolesInfo.vue";
import rolesUser from "../views/systerm/userConfig/role/rolesUser.vue";

//model 版块
// model 版块内容

import Item from "../views/model/item/item.vue"; //物料页
// import TitleBlock from '../views/model/item/titleBlock.vue' //物料页
import Bom from "../views/model/item/BOM.vue"; //物料页
import ItemChanges from "../views/model/item/itemChanges.vue"; //物料页
import ItemWhereUsed from "../views/model/item/itemWhereUsed.vue"; //
import ItemAttachment from "../views/model/item/itemAttachment.vue"; //物料页
// import Relationship from '../views/model/item/relationship.vue'
import ItemHistory from "../views/model/item/itemHistory.vue"; //物料页
import Manufacturers from "../views/model/item/manufacturers.vue"; //制造商页

//common组件
import Attachment from "@/components/common/Attachment.vue";

import Relationship from "@/components/common/Relationship.vue";
import PageInfo from "../views/model/common/pageInfo.vue"; //
//change 版块
import ChangePage from "../views/model/change/changePage.vue"; //变更页
// import ChangeTitleBlock from '../views/model/change/changeTitleBlock.vue' //变更页
import ChangeAffectedItem from "../views/model/change/changeAffectedItem.vue"; //变更页
import ChangeWorkflow from "../views/model/change/changeWorkflow.vue"; //变更页
import ChangeHistory from "../views/model/change/changeHistory.vue"; //变更页

//制造商
import ManuFactPage from "../views/model/manufacturer/ManuFactPage"; //制造商
// import ManuFactTitleBlock from '../views/model/manufacturer/ManuFactTitleBlock.vue' //制造商
import ManuFactWhereUsed from "../views/model/manufacturer/ManuFactWhereUsed.vue"; //制造商
import ManuFactHistory from "../views/model/manufacturer/ManuFactHistory.vue"; //制造商
//制造商部件
import ManuFactPartPage from "../views/model/manufacturerPart/ManuFactPartPage"; // 制造商部件
//import ManuFactPartTitleBlock from '../views/model/manufacturerPart/ManuFactPartTitleBlock.vue' // 制造商部件
import ManuFactPartWhereUsed from "../views/model/manufacturerPart/ManuFactPartWhereUsed.vue"; // 制造商部件
import ManuFactPartHistory from "../views/model/manufacturerPart/ManuFactPartHistory.vue"; // 制造商部件
//质量板块
import QualityPage from "../views/model/quality/qualityPage.vue";
import QualityRelationItem from "../views/model/quality/qualityRelationItem.vue"; //质量-问题对象
import QualityWorkflow from "../views/model/quality/qualityWorkflow.vue"; //质量-工作流
import QualityRelevance from "../views/model/quality/qualityRelevance.vue"; //质量-关联相同表单
import QualityHistory from "../views/model/quality/qualityHistory.vue"; //质量-历史记录

//工艺
import TechnologyPage from "../views/model/technology/technologyPage.vue";
import TechnologyChange from "../views/model/technology/technologyChange.vue";
import TechnologyBOM from "../views/model/technology/technologyBOM.vue";
import TechnologyRelatedItem from "../views/model/technology/technologyRelatedItem.vue";
import TechnologyRelatedResource from "../views/model/technology/technologyRelatedResource.vue";
import TechnologyRelatedTechnology from "../views/model/technology/technologyRelatedTechnology.vue";
import TechnologyHistory from "../views/model/technology/technologyHistory.vue";

//资源库
import ResourcePage from "../views/model/resource/ResourcePage.vue";
import ResourceWhereUsed from "../views/model/resource/ResourceWhereUsed.vue";
import ResourceHistory from "../views/model/resource/ResourceHistory.vue";
import ResourceRelatedResource from "../views/model/resource/resourceRelatedResource.vue";

//project
import Project from "../views/project/project";
import projectTitle from "../views/project/content/titleBlock/projectTitle";

// ganttChart
import gantt from "@/views/ScheduleManagGantt/ganttChart.vue";
// import criticalPath from "@/views/ScheduleManagGantt/criticalPath.vue";

//登录页
//import LoginDemo1 from '../views/login/Login1.vue'
//import LoginDemo2 from '../views/login/Login2.vue'
//import LoginDemo3 from '../views/login/Login3.vue'
import index from "../views/login/index.vue";
import terms from "../views/login/terms.vue"; //登录协议
import privacy from "../views/login/privacy.vue"; //用户隐私
//import Login from '../components/Login.vue'

import importAgileList from "../views/agileImport/importAgileList.vue"; //agile列表导入
import importAgileClass from "../views/agileImport/importAgileClass.vue"; //agile Class导入

//工作台
import Welcome from "../views/workBench/myProcess/Welcome.vue"; //我的流程
import Echarts from "../views/workBench/myDashboard/Echarts.vue"; //--我的仪表
import MyProject from "../views/workBench/myProject/myProject.vue"; //--我的项目
import MyAgent from "../views/workBench/myAgent/myAgent.vue"; //我的任务
import Folders from "../views/workBench/myDocuments/Folders.vue"; //我的文档
import Documents from "../views/workBench/myDocuments/docs/Documents.vue"; //文档

import MyDiscusion from "../views/workBench/myDiscussion/myDiscussion.vue"; //我的讨论

// 快速搜索
import SimpleSearch from "../views/workBench/search/simpleSearch.vue"; //快速搜索页
import DeletedObjects from "../views/workBench/search/deletedObjects.vue"; //快速搜索页
import DashboardShow from "../views/workBench/search/dashboardShow.vue"; //快速搜索页
// import SearchTerms from '../views/workBench/search/SearchTerms.vue' //高级搜索页
// import RecentVistFavorite from '../views/search/RecentVistFavorite.vue' //最近访问收藏页面
// 我的通知
// import MyNotice from "../views/workBench/myNotice/myNotice.vue";
//个人设定
//admin
import MyServlet from "../views/workBench/myServlet/myServlet.vue"; //个人设定
import UpDatePsd from "../views/workBench/myServlet/updatePsd.vue"; //密码修改

import LoginLog from "../components/log/LoginLog.vue"; //登入日志

//产品信息维护
//import Departments from '../components/department/Departments.vue'

//我的创建
//import MyCreate from '../components/workBench/MyCreate.vue'

Vue.use(VueRouter);
//页面标题

//document.title = "swift: 欢迎, " +''

const routes = [
  {
    path: "/gantt/",
    name: "Gantt",
    component: gantt,
  },
  // {
  //   path: "/criticalPath/",
  //   name: "criticalPath",
  //   component: criticalPath,
  // },

  {
    path: "/index",
    name: "index",
    component: index,
  },
  {
    path: "/terms",
    name: "terms",
    component: terms,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: privacy,
  },
  //
  {
    path: "/",
    redirect: "/index",
  },

  {
    path: "/BomComparison",
    component: () => import("../views/reports/BOMComparison"),
  },

  {
    path: "/home",
    component: Home,
    meta: {
      title: "Swift",
    },
    // redirect: '/echarts',
    children: [
      {
        //我的工作台
        path: "/welcome",
        component: Welcome,
        name: "Welcome",
        meta: {},
      },
      {
        //个人设定
        path: "/myServlet",
        component: MyServlet,
        meta: {},
      },
      {
        //密码修改
        path: "/upDatePsd",
        component: UpDatePsd,
        meta: {},
      },
      {
        //文档
        path: "/document",
        component: Document,
        meta: {},
      },
      {
        //我的文件夹
        path: "/folders",
        component: Folders,
      },
      // {
      //   //我的通知
      //   path: "/myNotice",
      //   component: MyNotice,
      // },
      ,
      // {
      // 	path: '/myCreate',
      // 	component: MyCreate,
      // }
      {
        path: "/myProject",
        component: MyProject,
      },
      {
        path: "/myAgent",
        component: MyAgent,
      },
      // {
      // 	path: '/departments',
      // 	component: Departments,
      // },
      {
        path: "/echarts",
        component: Echarts,
      },
      {
        path: "/myDiscussion",
        component: MyDiscusion,
      },
      {
        path: "/myProject",
        component: () => import("../views/workBench/myProject/myProject"),
      },

      //创建栏
      {
        path: "/parts",
        name: "Parts",
        component: () => import("../views/create/CreateItem.vue"),
      },
      {
        path: "/documents",
        name: "Documents",
        component: Documents,
      },
      {
        path: "/Attachment",
        name: "Attachment",
        component: Attachment,
      },
      {
        path: "/createChange",
        name: "CreateChange",
        component: () => import("../views/create/CreateChange.vue"),
      },
      {
        path: "/CreateManufacturer",
        name: "CreateManufacturer",
        component: () => import("../views/create/CreateManufacturer.vue"),
      },
      {
        path: "/CreateManufacturerPart",
        name: "CreateManufacturerPart",
        component: () => import("../views/create/CreateManufacturerPart.vue"),
      },
      {
        path: "/QuickCreate",
        name: "QuickCreate",
        component: () => import("../views/create/QuickCreate.vue"),
      },
      {
        path: "/createProject",
        name: "CreateProject",
        component: () => import("../views/create/CreateProject.vue"),
      },
      {
        path: "/quality",
        name: "CreateQuality",
        component: () => import("../views/create/CreateQuality.vue"),
      },
      {
        path: "/technology",
        name: "CreateTechnology",
        component: () => import("../views/create/CreateTechnology.vue"),
      },
      {
        path: "/resource",
        name: "CreateResource",
        component: () => import("../views/create/CreateResource.vue"),
      },
      //快速搜索
      {
        path: "/SimpleSearch",
        name: "SimpleSearch",
        component: SimpleSearch,
      },
      {
        path: "/DeletedObjects",
        name: "DeletedObjects",
        component: DeletedObjects,
      },
      {
        path: "/dashboardShow",
        name: "DashboardShow",
        component: DashboardShow,
      },
      // {
      // 	path: '/advancedSearch',
      //
      // 	component: Show,
      // },
      {
        path: "/advancedSearch",
        component: () => import("../views/workBench/search/advancedSearch"),
        meta: {
          keepAlive: true,
        },
      },
      { path: "/folderList", component: folderList },
      {
        path: "/personalSearch",
        component: () => import("../views/workBench/search/personalSearch"),
      },
      {
        path: "/globalSearch",
        component: () => import("../views/workBench/search/globalSearch"),
      },
      // {
      // 	path: '/recentVistFavorite',
      // 	name: 'RecentVistFavorite',
      // 	component: RecentVistFavorite,
      // },
      // {
      // 	path: '/searchTerms',
      // 	name: 'SearchTerms',
      // 	component: SearchTerms
      // }

      ////系统配置
      {
        path: "/metaconfig",
        component: Metaconfig,
      },
      ////报表
      // , {
      // 	path: '/reports',
      // 	component: Reports,
      // },

      {
        path: "/lists",
        component: Lists,
        name: "Lists",
        meta: {},
        children: [
          {
            path: "/listInfo",
            component: ListInfo,
            name: "ListInfo",
          },
        ],

        // children: [
        //   {
        //     name: "listInfo",
        //     path: "",
        //     redirect: "listInfo",
        //   },
        //   {
        //     path: "listInfo",
        //     component: listInfo,
        //   },
        //   {
        //     path: "listValue",
        //     component: listValue,
        //   },
        //   {
        //     path: "whereused",
        //     component: listWhereused,
        //   },
        // ],
      },
      {
        path: "/autoNumbers",
        name: "AutoNumbers",
        component: AutoNumbers,
        children: [
          {
            path: "AutoNumbersInfo",
            component: AutoNumbersInfo,
            meta: {},
          },
          {
            path: "AutoNumbersWhereUsed",
            component: AutoNumbersWhereUsed,
            meta: {},
          },
        ],
      },
      {
        path: "/codeNumbers",
        name: "CodeNumbers",
        component: CodeNumbers,
      },
      {
        path: "/criteria",
        name: "Criteria",
        component: Criteria,
      },
      {
        path: "/workflows",
        name: "Workflows",
        component: Workflows,
      },
      {
        path: "/projectWorkflows",
        name: "ProjectWorkflows",
        component: ProjectWorkflows,
      },
      {
        path: "/ppmWorkflows",
        name: "PpmWorkflows",
        component: PpmWorkflows,
      },
      {
        path: "/workflowInfo",
        name: "WorkflowInfo",
        component: WorkflowInfo,
      },
      {
        path: "/projectWorkflowInfo",
        name: "ProjectWorkflowInfo",
        component: ProjectWorkflowInfo,
      },
      {
        path: "/PpmWorkflowInfo",
        name: "PpmWorkflowInfo",
        component: PpmWorkflowInfo,
      },
      {
        path: "/classes",
        component: Classes,
        name: "Classes",
      },
      {
        path: "/notifications",
        component: Notifications,
        name: "Notifications",
      },
      {
        path: "/Integration",
        component: Integration,
        name: "Integration",
      },
      {
        path: "/preference",
        component: Preference,
        name: "Preference",
      },
      {
        path: "/createUser",
        component: CreateUser,
      },
      {
        path: "/Users",
        component: Users,
        children: [
          {
            path: "UserInfo",
            component: PageInfo,
            meta: {},
          },
          {
            path: "RolePermission",
            component: RolePermission,
            meta: {},
          },
          {
            path: "UserPreferences",
            component: UserPreferences,
            meta: {},
          },
          {
            path: "UserAuthorization",
            component: UserAuthorization,
            meta: {},
          },
          {
            path: "UserGroup",
            component: UserGroup,
            meta: {},
          },
          {
            path: "UserAttachment",
            component: ItemAttachment,
            meta: {},
          },
          {
            path: "UserHistory",
            component: UserHistory,
            meta: {},
          },
        ],
      },

      {
        path: "/adminUpdatePsd",
        component: AdminUpdatePsd,
      },
      {
        path: "/importAgileList",
        component: importAgileList,
      },
      {
        path: "/importAgileClass",
        component: importAgileClass,
      },
      {
        path: "/UserItem",
        component: UserItem,
        meta: {},
        children: [
          {
            path: "/UserInfo",
            component: PageInfo,
            meta: {},
          },
          {
            path: "/UserAttachment",
            component: ItemAttachment,
            meta: {},
          },
          {
            path: "/UserAttachment2",
            component: ItemAttachment,
            meta: {},
          },
          {
            path: "/UserHistory",
            component: UserHistory,
            meta: {},
          },
          {
            path: "/UserGroup",
            component: UserGroup,
            meta: {},
          },
          {
            path: "/UserAuthorization",
            component: UserAuthorization,
            name: UserAuthorization,
            meta: {},
          },
          {
            path: "/UserPreferences",
            component: UserPreferences,
            name: UserPreferences,
            meta: {},
          },
        ],
      },
      //
      {
        path: "/createUserGroup",
        component: CreateUserGroup,
      },
      {
        path: "/UserGroups",
        // name:UserGroups,
        component: UserGroups,
      },
      {
        path: "/UserGroupItem",
        // name:UserGroupItem,
        component: UserGroupItem,
        meta: {},
        children: [
          {
            path: "/UserGroupInfo",
            // name:UserGroupInfo,
            component: PageInfo,
            meta: {},
          },
          {
            path: "/UserGroupUsers",
            // name:UserGroupUsers,
            component: UserGroupUsers,
            meta: {},
          },
          {
            path: "/UserGroupHistory",
            component: UserGroupHistory,
            // name:UserGroupHistory,
            meta: {},
          },
          {
            path: "/UserGroupRelationship",
            component: Relationship,
            // name:UserGroupRelationship,
            meta: {},
          },
          {
            path: "/UserGroupAttachment",
            component: ItemAttachment,
            // name:UserGroupAttachment,
            meta: {},
          },
          {
            path: "/UserGroupAttachment2",
            component: ItemAttachment,
            // name:UserGroupAttachment,
            meta: {},
          },
          {
            path: "/UserGroupAssignment",
            component: UserGroupAssignment,
            // name:UserGroupAssignment,
            meta: {},
          },
        ],
      },

      {
        path: "/BOMCompareReport",
        component: () => import("../views/reports/BOMCompar"),
      },

      {
        path: "/loginLog",
        component: LoginLog,
      },
      // {
      // 	path: '/logs',
      // 	component: Logs
      // },
      // {
      //   path: "/roles",
      //   name: "Roles",
      //   component: Roles,
      // },
      {
        path: "/privs",
        name: "Privs",
        component: Privs,
        children: [
          {
            name: "privsInfo",
            path: "",
            redirect: "privsInfo",
          },
          {
            path: "privsInfo",
            component: privInfo,
          },
          {
            path: "privsRole",
            component: privRole,
          },
          {
            path: "privsUser",
            component: privUser,
          },
        ],
      },
      {
        path: "/roles",
        name: "roles",
        component: Roles,
        children: [
          {
            name: "rolesInfo",
            path: "",
            redirect: "rolesInfo",
          },
          {
            path: "rolesInfo",
            component: rolesInfo,
          },

          {
            path: "rolesUser",
            component: rolesUser,
          },
        ],
      },

      {
        path: "/item",
        component: Item,
        meta: {},
        children: [
          {
            path: "/titleBlock",
            component: PageInfo,
            meta: {},
          },
          {
            path: "/bom",
            component: Bom,
            name: "BOM",
            meta: {},
          },
          {
            path: "/itemRelationship",
            component: Relationship,
            meta: {},
          },
          {
            path: "/itemQualityPage",
            component: () => import("../views/model/item/quality"),
          },
          {
            path: "/itemRelatedTechnology",
            component: () =>
              import("../views/model/item/itemRelatedTechnology"),
          },
          {
            path: "/itemChanges",
            component: ItemChanges,
            meta: {},
          },
          {
            path: "/itemWhereUsed",
            component: ItemWhereUsed,
            meta: {},
          },
          {
            path: "/itemHistory",
            component: ItemHistory,
            meta: {},
          },
          {
            path: "/itemAttachment",
            component: ItemAttachment,
            meta: {},
          },
          {
            path: "/itemAttachment2",
            name: "itemAttachment2",
            component: ItemAttachment,
          },
          {
            path: "/manufacturers",
            component: Manufacturers,
            meta: {},
          },
        ],
      },
      {
        path: "/changePage",
        component: ChangePage,
        children: [
          {
            path: "/changeTitleBlock",
            component: PageInfo,
            meta: {},
          },
          {
            path: "/changeAffectedItem",
            component: ChangeAffectedItem,
            meta: {},
          },
          {
            path: "/changeWorkflow",
            name: "changeWorkflow",
            component: ChangeWorkflow,
          },
          {
            path: "/changeAttachment",
            name: "changeAttachment",
            component: ItemAttachment,
          },
          {
            path: "/changeAttachment2",
            name: "changeAttachment2",
            component: ItemAttachment,
          },
          {
            path: "/changeRelationship",
            // name: 'changeRelationship',
            component: Relationship,
          },
          {
            path: "/changeHistory",
            name: "changeHistory",
            component: ChangeHistory,
          },
        ],
      },

      {
        path: "/qualityPage",
        component: QualityPage,
        children: [
          {
            path: "/qualityTitleBlock",
            component: PageInfo,
          },
          {
            path: "/qualityWorkflow",
            name: "qualityWorkflow",
            component: QualityWorkflow,
            // component:() => import('../views/model/quality/qualityWorkflow.vue')
          },
          {
            path: "/qualityRelationItem",
            component: QualityRelationItem,
          },
          {
            path: "/qualityRelevance",
            component: QualityRelevance,
          },
          {
            path: "/qualityAttachment",
            name: "qualityAttachment",
            component: ItemAttachment,
          },
          {
            path: "/qualityRelationship",
            // name: 'qualityRelationship',
            component: Relationship,
          },
          {
            path: "/qualityHistory",
            // name: 'qualityRelationship',
            component: QualityHistory,
          },
        ],
      },

      {
        path: "/technologyPage",
        component: TechnologyPage,
        children: [
          {
            path: "/technologyTitleBlock",
            component: PageInfo,
          },
          {
            path: "/technologyChange",
            name: "technologyChange",
            component: TechnologyChange,
          },
          {
            path: "/technologyBOM",
            name: "technologyBOM",
            component: TechnologyBOM,
          },
          {
            path: "/technologyRelatedItem",
            name: "technologyRelatedItem",
            component: TechnologyRelatedItem,
          },
          {
            path: "/technologyRelatedResource",
            name: "technologyRelatedResource",
            component: TechnologyRelatedResource,
          },
          {
            path: "/technologyRelatedTechnology",
            name: "technologyRelatedTechnology",
            component: TechnologyRelatedTechnology,
          },
          {
            path: "/technologyAttachment",
            name: "technologyAttachment",
            component: ItemAttachment,
          },
          {
            path: "/technologyHistory",
            name: "technologyHistory",
            component: TechnologyHistory,
          },
        ],
      },

      {
        path: "/ResourcePage",
        component: ResourcePage,
        children: [
          {
            path: "/ResourceRelationship",
            component: Relationship,
          },
          {
            path: "/ResourceTitleBlock",
            // name: 'ResourceTitleBlock',
            component: PageInfo,
          },
          {
            path: "/ResourceRelatedResource",
            // name: 'ResourceRelatedResource',
            component: ResourceRelatedResource,
          },
          {
            path: "/ResourceRelatedtechnology",
            component: ResourceWhereUsed,
          },
          {
            path: "/ResourceAttachment",
            // name: 'ResourceAttachment',
            component: ItemAttachment,
          },
          {
            path: "/ResourceHistory",
            component: ResourceHistory,
          },
        ],
      },

      {
        path: "/ManuFactPage",
        component: ManuFactPage,
        children: [
          {
            path: "/ManuFactRelationship",
            component: Relationship,
          },
          {
            path: "/ManuFactTitleBlock",
            // name: 'ManuFactTitleBlock',
            component: PageInfo,
          },
          {
            path: "/ManuFactAttachment",
            name: "ManuFactAttachment",
            component: ItemAttachment,
          },
          {
            path: "/ManuFactAttachment2",
            name: "ManuFactAttachment2",
            component: ItemAttachment,
          },
          {
            path: "/ManuFactWhereUsed",
            component: ManuFactWhereUsed,
          },
          {
            path: "/ManuFactHistory",
            component: ManuFactHistory,
          },
        ],
      },
      {
        path: "/ManuFactPartPage",
        component: ManuFactPartPage,
        children: [
          {
            path: "/ManuFactPartRelationship",
            component: Relationship,
          },
          {
            path: "/ManuFactPartTitleBlock",
            // name: 'ManuFactPartTitleBlock',
            component: PageInfo,
          },
          {
            path: "/ManuFactPartAttachment",
            name: "ManuFactPartAttachment",
            component: ItemAttachment,
          },
          {
            path: "/ManuFactPartAttachment2",
            name: "ManuFactPartAttachment2",
            component: ItemAttachment,
          },
          {
            path: "/ManuFactPartWhereUsed",
            component: ManuFactPartWhereUsed,
          },
          {
            path: "/ManuFactPartHistory",
            component: ManuFactPartHistory,
          },
        ],
      },
      {
        path: "/project",
        // component: () => import('../views/project/project'),
        component: Project,
        children: [
          {
            path: "/projectTitle",
            // component: () => import('../views/project/content/titleBlock/projectTitle')},
            component: projectTitle,
          },
          {
            path: "/projectSchedule",
            component: () =>
              import("../views/project/content/schedule/schedule"),
          },
          {
            path: "/projectTeam",
            component: () => import("../views/project/content/team"),
          },
          {
            path: "/projectScheduleComments",
            component: () =>
              import("../views/project/content/projectScheduleComments"),
          },

          // {	path: '/projectWorkflow',
          // 	component: () => import('../views/project/content/workflow/workflow')},
          {
            path: "/ProjectAttachment",
            name: "ProjectAttachment",
            component: ItemAttachment,
          },

          {
            path: "/projectDeliverable",
            component: () => import("../views/project/content/deliverable"),
          },
          {
            path: "/projectWorkflowInformation",
            component: () =>
              import("../views/project/content/workflowInformation"),
          },
          {
            path: "/projectHistory",
            component: () => import("../views/project/content/history"),
          },
        ],
      },
      {
        path: "/importFlie",
        component: () => import("../views/import/ImportFile"),
      },
      {
        path: "/importCommonItems",
        component: () => import("../views/import/importCommonItems"),
      },
      {
        path: "/importBoms",
        component: () => import("../views/import/ImportBOM"),
      },
      {
        path: "/importRelationship",
        component: () => import("../views/import/importRelationship"),
      },
      {
        path: "/importMfrp",
        component: () => import("../views/import/importMfrp"),
      },
      {
        path: "/importBomsNew",
        component: () => import("../views/import/ImportBOMsNew"),
      },
      {
        path: "/importBOMsByLevel",
        component: () => import("../views/import/ImportBOMsByLevel"),
      },

      {
        path: "/importBOMsByLevelNew",
        component: () => import("../views/import/importCommonBOMByLevel"),
      },
      {
        path: "/importCommonTaskRecords",
        component: () => import("../views/import/ImportProjectRecord"),
      },
      {
        path: "/performanceForm",
        component: () => import("../views/performanceForm/PerformanceForm"),
      },
      {
        path: "/BOMReport",
        component: () => import("../views/reports/BOMReport"),
      },
      {
        path: "/standardReport",
        component: () => import("../views/reports/standardReport"),
      },
      {
        path: "/scheduleReport",
        component: () => import("../views/reports/scheduleReport"),
      },
      {
        path: "/projectReport",
        component: () => import("../views/reports/projectReport"),
      },
      {
        path: "/calendar",
        component: () => import("../views/systerm/adminConfig/calendar.vue"),
      },

      {
        path: "/componentLibrary",
        component: () =>
          import("../views/workBench/componentLibrary/index.vue"),
      },

      {
        path: "/componentLibraryConfig",
        component: () =>
          import("../views/systerm/dataConfig/componentLibraryConfig.vue"),
      },

      {
        path: "/riskReport",
        component: () => import("../views/test/test.vue"),
        meta: { comp: "RiskReport" },
      },
      {
        path: "/questionManageReport",
        component: () => import("../views/test/test.vue"),
        meta: { comp: "ManageReport" },
      },
      {
        path: "/projectGlobalView",
        component: () => import("../views/test/test.vue"),
        meta: { comp: "GlobalView" },
      },
      {
        path: "/projectChartView",
        component: () => import("../views/test/test.vue"),
        meta: { comp: "EChartView" },
      },
      // {
      //   path: "/projectload",
      //   component: () => import("../views/test/projectLoad.vue"),
      // },

      // {
      //   path: "/test",
      //   component: () => import("../views/test/test.vue"),
      // },
      // {
      //   path: "/test2",
      //   component: () => import("../views/test/test2.vue"),
      // },
      {
        path: "/drawingImport",
        component: () => import("../views/import/drawingImport/index.vue"),
      },

      {
        path: "/combinatorialDescription",
        component: () =>
          import("../views/systerm/dataConfig/combinatorialDescription.vue"),
      },
      {
        path: "/settingAPI",
        component: () =>
          import("../views/systerm/dataConfig/settingAPI/index.vue"),
        children: [
          {
            // name: "privsInfo",
            path: "",
            redirect: "info",
          },
          {
            path: "info",
            component: () =>
              import("../views/systerm/dataConfig/APIConfig/info.vue"),
          },
          {
            path: "history",
            component: () =>
              import("../views/systerm/dataConfig/APIConfig/history.vue"),
          },
          {
            path: "whereused",
            component: () =>
              import("../views/systerm/dataConfig/APIConfig/whereused.vue"),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// import store from '../store' //引入store

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();

  // if (!store.state.pageChanged) {
  // 	next();
  // } else {
  // 	var r = confirm("当前页面有未保存信息，确定离开么");
  // 	if (r)	{
  // 		// store.state.pageChanged = false;
  // 		store.commit('setPageChanged',false)
  // 		next()
  // 	}	else{
  // 		return
  // 	}
  // }
});

//路由导航守卫
// router.beforeEach((to, from, next) => {

//   const token = window.localStorage.getItem('JWT_TOKEN');
//   if (to.path == '/login') {
//     if(!token){
//       return next();
//     }else{
//       return next({path: '/home'})
//     }
//   }

//   if(to.path=='/401'){
// 	  return next();
//   }

//   if (!token) {
//     return next('/login');
//   }else {
//     //判断是否有访问该路径的权限
//     const urls =store.state.userInfo.url;
//     //如果是管理员
//     if(store.state.userInfo.isAdmin){
//        return next();
//     }else{
//       if(urls.indexOf(to.path) > -1){
//         //则包含该元素
//         window.sessionStorage.setItem("activePath", to.path);
//         return next();
//       }else{
//         return next("/401");
//       }
//     }
//   }
// })

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
